// /client/src/components/ResetPassword.js
import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import NavigationPublic from './NavigationPublic';

const ResetPassword = () => {
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [success, setSuccess] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');

    try {
      const response = await fetch('/api/contacts/request-password-reset', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({ email: email.trim().toLowerCase() })
      });

      const data = await response.json();

      if (response.ok) {
        setSuccess(true);
      } else {
        setError(data.error || 'Failed to send reset email. Please try again.');
      }
    } catch (error) {
      console.error('Error requesting password reset:', error);
      setError('Network error. Please check your connection and try again.');
    } finally {
      setLoading(false);
    }
  };

  if (success) {
    return (
      <div className="m-0 p-0 hero is-fullheight">
        <NavigationPublic />
        <div className="m-0 p-0 is-flex is-flex-direction-column hero-body">
          <div className="m-0 p-0 container">
            <div className="m-0 p-0 columns is-centered">
              <div className="m-0 p-0 column is-5-tablet is-4-desktop is-5-widescreen">
                <div className="m-4 p-6 box borderRadius backgroundColorGrey">
                  <h1 className="pb-3 h1 colorBlack is-bold">Check Your Email</h1>
                  
                  <div className="notification is-success is-light">
                    <p>
                      If an account exists with the email <strong>{email}</strong>, 
                      you will receive a password reset link shortly.
                    </p>
                  </div>
                  
                  <p className="mt-4 mb-4">
                    Please check your inbox and spam folder. The link will expire in 1 hour.
                  </p>
                  
                  <div className="pt-3 field">
                    <Link to="/login" className="button is-fullwidth">
                      Return to Login
                    </Link>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="m-0 p-0 hero is-fullheight">
      <NavigationPublic />
      <div className="m-0 p-0 is-flex is-flex-direction-column hero-body">
        <div className="m-0 p-0 container">
          <div className="m-0 p-0 columns is-centered">
            <div className="m-0 p-0 column is-5-tablet is-4-desktop is-5-widescreen">
              <form onSubmit={handleSubmit} className="m-4 p-6 box borderRadius backgroundColorGrey">
                <h1 className="pb-3 h1 colorBlack is-bold">Reset Password</h1>
                
                <p className="mb-4">
                  Enter your email address and we'll send you a link to reset your password.
                </p>

                {error && (
                  <div className="notification backgroundColorError">
                    <button 
                      className="delete" 
                      onClick={() => setError('')}
                    ></button>
                    {error}
                  </div>
                )}

                <div className="field">
                  <label className="m-0 p-0 label">Email</label>
                  <div className="m-0 p-0 control">
                    <input
                      className="input"
                      type="email"
                      name="email"
                      placeholder="your@email.com"
                      value={email}
                      onChange={(e) => {
                        setEmail(e.target.value);
                        setError('');
                      }}
                      required
                      autoFocus
                    />
                  </div>
                </div>

                <div className="pt-5 field">
                  <button 
                    className={`button is-fullwidth ${loading ? 'is-loading' : ''}`}
                    type="submit"
                    disabled={loading || !email.trim()}
                  >
                    Send Reset Link
                  </button>
                </div>
              </form>

              <div className='is-flex is-justify-content-center'>
                <p className='is-bold psmall'>
                  <Link to="/login">Back to Login</Link>
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ResetPassword;